import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import i18n from './plugins/i18n'
import axios from 'axios'
import VueAxios from 'vue-axios'
import commonMethods from './commonMethods'

import VCalendar from 'v-calendar'
import 'v-calendar/style.css'
import arrastreTotem from './plugins/arrastreTotem'
import inactividadTotem from './plugins/inactividadTotem'

if (/[?&]modo=totem([&#?]|$)/.test(window.location.search)) {
  sessionStorage.setItem('modoTotem', '1')
}
if (sessionStorage.getItem('modoTotem') === '1') {
  arrastreTotem()
  inactividadTotem()
}

const iOS = () => {
  return (
    [
      'iPad Simulator',
      'iPhone Simulator',
      'iPod Simulator',
      'iPad',
      'iPhone',
      'iPod'
    ].includes(navigator.platform) ||
    // iPad on iOS 13 detection
    (navigator.userAgent.includes('Mac') && 'ontouchend' in document)
  )
}

if (!iOS()) {
  import('./plugins/firebase')
}

const app = createApp(App)
  .use(i18n)
  .use(store)
  .use(router)
  .use(VueAxios, axios)
  .use(VCalendar, {})
app.config.errorHandler = (err, vm, info) => {
  const { registerError } = commonMethods()
  registerError(err, info)
}
/*
 * Una imagen que no carga se queda con el icono de imagen rota del navegador, y
 * eso se lee como una pagina averiada en vez de como una ficha a la que le
 * falta la foto. Se cambia por el hueco gris que sirve el API, que es lo que
 * dice la verdad: aqui falta una imagen.
 *
 * Va aqui y en captura, no en cada <img>: asi vale para las que hay y para las
 * que se anadan, y no hay que acordarse. La captura hace falta porque el evento
 * de error de una imagen NO burbujea.
 *
 * Solo se tocan las que vienen de fuera del bundle -una direccion entera del
 * bucket o el `null` de un campo vacio-. Una imagen del propio bundle que no
 * cargue es otra cosa, y taparla esconderia un fallo de construccion.
 */
const huecoDeImagen = (process.env.VUE_APP_PATH || '/external/') + 'imagen/'
document.addEventListener(
  'error',
  (evento) => {
    const img = evento.target
    if (!(img instanceof HTMLImageElement) || img.dataset.hueco) return

    const src = img.getAttribute('src') || ''
    if (!/^https?:\/\//.test(src) && src !== 'null' && !src.endsWith('/null')) return

    // La marca evita la vuelta infinita si el hueco tampoco cargara.
    img.dataset.hueco = '1'

    const caja = img.getBoundingClientRect()
    const apaisada = caja.height > 0 && caja.width / caja.height >= 2
    img.src = huecoDeImagen + (apaisada ? 'sin-portada.svg' : 'sin-miniatura.svg')
  },
  true
)

app.mount('#app')
